import type { WorkingTreeChangeKind } from '../types.js';
import { normalizeGitDiffPath } from './normalize-git-diff-path.js';
import type { NameStatusEntry } from './types.js';

export function parseNameStatusEntries(lines: string[]): NameStatusEntry[] {
  const entries: NameStatusEntry[] = [];
  for (const line of lines) {
    if (!line.trim()) continue;
    const tabParts = line.split('\t');
    if (tabParts.length < 2) continue;
    const status = tabParts[0].trim();
    const code = status[0];
    if (code === 'A') {
      entries.push({ pathInRepo: normalizeGitDiffPath(tabParts[tabParts.length - 1]!), change: 'added' });
    } else if (code === 'D') {
      entries.push({ pathInRepo: normalizeGitDiffPath(tabParts[tabParts.length - 1]!), change: 'removed' });
    } else if (code === 'R' || code === 'C') {
      if (tabParts.length >= 3) {
        entries.push({
          pathInRepo: normalizeGitDiffPath(tabParts[tabParts.length - 1]!),
          oldPathInRepo: normalizeGitDiffPath(tabParts[tabParts.length - 2]!),
          change: 'moved',
        });
      }
    } else if (code === 'M' || code === 'U' || code === 'T') {
      entries.push({ pathInRepo: normalizeGitDiffPath(tabParts[tabParts.length - 1]!), change: 'modified' });
    }
  }
  return entries;
}

export function parseNameStatusLines(lines: string[]): Map<string, WorkingTreeChangeKind> {
  const m = new Map<string, WorkingTreeChangeKind>();
  for (const entry of parseNameStatusEntries(lines)) {
    m.set(entry.pathInRepo, entry.change);
  }
  return m;
}
